export default "__VITE_ASSET__CEYXGc10__"